import { c as _c } from "react/compiler-runtime";
import { Box, Button, HStack, Icon, Link, Spacer, Text, VStack } from '@chakra-ui/react';
import { KeywordInput } from '@src/components/sco/InvestorSearch/InvestorSearchFilters/KeywordInput';
import { CompanyIndustryTagInput } from '@src/components/sco/Members/MemberSearchFilterForm/CompanyIndustryTagInput';
import { CompanyStageTagInput } from '@src/components/sco/Members/MemberSearchFilterForm/CompanyStageTagInput';
import { ToggleInput } from '@src/components/sco/Members/MemberSearchFilterForm/ToggleInput';
import { useMemberSearchFilters, useMemberSearchPagination } from '@src/components/sco/Members/MemberSearchResults';
import { usePathname } from 'next/navigation';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { MdFilterList } from 'react-icons/md';
export type MemberSearchFiltersProps = {};
export const MemberSearchFilterForm = props => {
  const $ = _c(56);
  const router = useRouter();
  const pathname = usePathname();
  const [pagination] = useMemberSearchPagination();
  const [filters, filterValues] = useMemberSearchFilters();
  const [values, setValues] = useState(filterValues);
  const [filtersChanged, setFiltersChanged] = useState(false);
  let t0;
  if ($[0] !== values) {
    t0 = (key, value) => {
      setValues({
        ...values,
        [key]: value
      });
      setFiltersChanged(true);
    };
    $[0] = values;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const setValue = t0;
  let t1;
  if ($[2] !== filters || $[3] !== pagination.page || $[4] !== pathname || $[5] !== router || $[6] !== values) {
    t1 = async () => {
      if (pathname !== "/members") {
        await router.push("/members");
      }
      Object.keys(values).forEach(key_0 => {
        filters[key_0]?.setValue(values[key_0]);
      });
      pagination.page.setValue(1);
      setFiltersChanged(false);
    };
    $[2] = filters;
    $[3] = pagination.page;
    $[4] = pathname;
    $[5] = router;
    $[6] = values;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const handleSubmit = t1;
  let t2;
  if ($[8] !== handleSubmit) {
    t2 = e => {
      e.preventDefault();
      handleSubmit();
    };
    $[8] = handleSubmit;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Icon asChild={true} boxSize={3} color="colorPalette.fg"><MdFilterList /></Icon>;
    t4 = <Text textStyle="label2xs">Filters</Text>;
    $[10] = t3;
    $[11] = t4;
  } else {
    t3 = $[10];
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <HStack align="center" justify="space-between" marginBottom={2} paddingY="1em" width="full"><HStack align="center">{t3}{t4}<Text as="span" display="inline-block" textStyle="label2xs">•<Link _hover={{
            color: "whiteAlpha.900"
          }} display="inline-block" href="/members" marginLeft="0.5em">Reset</Link></Text></HStack></HStack>;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== setValue) {
    t6 = value_0 => setValue("keywords", value_0);
    $[13] = setValue;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== filterValues.keywords || $[16] !== t6) {
    t7 = <KeywordInput defaultValue={filterValues.keywords} label="Keyword" placeholder="Name or company" onChange={t6} />;
    $[15] = filterValues.keywords;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Text textStyle="label2xs">Company Stage</Text>;
    t9 = <Spacer height="0.5em" />;
    $[18] = t8;
    $[19] = t9;
  } else {
    t8 = $[18];
    t9 = $[19];
  }
  let t10;
  if ($[20] !== setValue) {
    t10 = values_0 => setValue("companyStageKeys", values_0);
    $[20] = setValue;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== filterValues.companyStageKeys || $[23] !== t10) {
    t11 = <Box width="full">{t8}{t9}<CompanyStageTagInput defaultValue={filterValues.companyStageKeys} placeholder="Any" onChange={t10} /></Box>;
    $[22] = filterValues.companyStageKeys;
    $[23] = t10;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Text textStyle="label2xs">Company Industry</Text>;
    t13 = <Spacer height="0.5em" />;
    $[25] = t12;
    $[26] = t13;
  } else {
    t12 = $[25];
    t13 = $[26];
  }
  let t14;
  if ($[27] !== setValue) {
    t14 = values_1 => setValue("companyIndustryKeys", values_1);
    $[27] = setValue;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== filterValues.companyIndustryKeys || $[30] !== t14) {
    t15 = <Box width="full">{t12}{t13}<CompanyIndustryTagInput defaultValue={filterValues.companyIndustryKeys} placeholder="Any" onChange={t14} /></Box>;
    $[29] = filterValues.companyIndustryKeys;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== setValue) {
    t16 = value_1 => setValue("location", value_1);
    $[32] = setValue;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== filterValues.location || $[35] !== t16) {
    t17 = <KeywordInput defaultValue={filterValues.location} label="Location" placeholder="City, State, Country" onChange={t16} />;
    $[34] = filterValues.location;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== setValue) {
    t18 = value_2 => setValue("matchAll", value_2);
    $[37] = setValue;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== filterValues.matchAll || $[40] !== t18) {
    t19 = <ToggleInput defaultValue={filterValues.matchAll} label="Match All Filters" onChange={t18} />;
    $[39] = filterValues.matchAll;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t11 || $[43] !== t15 || $[44] !== t17 || $[45] !== t19 || $[46] !== t7) {
    t20 = <VStack align="stretch" gap="1.33em" overflow="auto" paddingBottom={4}>{t7}{t11}{t15}{t17}{t19}</VStack>;
    $[42] = t11;
    $[43] = t15;
    $[44] = t17;
    $[45] = t19;
    $[46] = t7;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  const t21 = !filtersChanged;
  const t22 = filtersChanged ? "cta" : "outline";
  const t23 = filtersChanged ? "Apply Filters" : "Filters Applied";
  let t24;
  if ($[48] !== t21 || $[49] !== t22 || $[50] !== t23) {
    t24 = <Box paddingY={4}><Button disabled={t21} type="submit" variant={t22} width="full">{t23}</Button></Box>;
    $[48] = t21;
    $[49] = t22;
    $[50] = t23;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] !== t2 || $[53] !== t20 || $[54] !== t24) {
    t25 = <VStack asChild={true} align="stretch" gap={0} height="full"><form onSubmit={t2}>{t5}{t20}{t24}</form></VStack>;
    $[52] = t2;
    $[53] = t20;
    $[54] = t24;
    $[55] = t25;
  } else {
    t25 = $[55];
  }
  return t25;
};